/* ================================================================
    SITE INIT - GLOBAL FUNCTIONS
    (flexslider plugin is loaded by the entry before this runs)
   ================================================================ */

import { setupToggles } from "./toggles";

// Kendo 2025 (SF 15.4) no longer expands the TreeView nav on toggle click: its structural CSS ships
// from the backend kendo_common resource, which 404s here, so the toggle has no working handler.
// Toggle the sub-group directly so the mobile + section nav accordions open again.
const setupTreeviewNav = function () {
  document.querySelectorAll<HTMLElement>(".sfNavTreeview").forEach((tree) => {
    tree.addEventListener("click", (e) => {
      const toggle = (e.target as HTMLElement).closest(".k-treeview-toggle");
      if (!toggle) return;

      e.preventDefault();
      const item = toggle.closest<HTMLElement>(".k-treeview-item, .k-item");
      const group = item?.querySelector<HTMLElement>(":scope > ul");
      if (!item || !group) return;

      const isHidden = window.getComputedStyle(group).display === "none";
      group.style.display = isHidden ? "block" : "none";
      item.setAttribute("aria-expanded", String(isHidden));
    });
  });
};

export const siteInit = function () {
  const navInner = document.querySelector<HTMLElement>(".navinnerwrp");
  if (navInner) {
    navInner.style.display = "block";
  }

  const loginWelcome = document.querySelector(".loginwelcome");
  if (loginWelcome) {
    loginWelcome.addEventListener("click", function () {
      const loginMenu = document.querySelector<HTMLElement>(".loginMenu");
      if (loginMenu) {
        const isHidden = window.getComputedStyle(loginMenu).display === "none";
        loginMenu.style.display = isHidden ? "block" : "none";
      }
    });
  }

  $(".flexslider").flexslider();

  $(".hero-banner-slider.sliderInit").flexslider({
    controlsContainer: $(".hero-banner-slider__controls"),
  });

  setupToggles();
  setupTreeviewNav();
};
